import { ITransactionType } from './../../models/transaction-type';

import { Injectable, OnInit } from '@angular/core';
import { DataService } from '../data-services/data.service';
import { IOrganization } from '../../models/organization';
import { Observable, ObservedValueTupleFromArray } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IOrganizationSubscription } from '../../models/organization-subscription';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService
  extends DataService<IOrganization>
  implements OnInit
{
  getSubscriptions(
    organizationId: string,
  ): Observable<Array<IOrganizationSubscription>> {
    const url = `${this.urlService.buildUrl(
      'account',
    )}/${organizationId}/subscriptions`;
    return this.http.get<Array<IOrganizationSubscription>>(`${url}`).pipe(
      map((res) => {
        res.forEach((item) => {
          this.setId(item);
        });
        return res;
      }),
      catchError(this.errorMgmt),
    );
  }

  getAddOnProducts(category?: string): Observable<Array<any>> {
    let url = `${this.urlService.buildUrl('product', 'service-product')}`;
    if (category) {
      url += `/${category}`;
    } else {
      // Get all active addon products - you'll need to create this endpoint
      url = `${this.urlService.buildUrl('products', 'subscription-product')}/addon`;
    }
    return this.http.get<Array<any>>(`${url}`).pipe(
      map((res) => {
        return res;
      }),
      catchError(this.errorMgmt),
    );
  }

  getApprovers(organizationId: any): Observable<Array<string>> {
    const url = `${this.urlService.buildUrl(
      'roles',
      'getApprovers',
    )}/${organizationId}`;
    return this.http.get<Array<string>>(`${url}`);
  }

  // This probably should not be here
  getTransactionTypes(): Observable<Array<ITransactionType>> {
    const url = `${this.urlService.buildUrl('transactions', 'types')}`;

    return this.http.get<Array<ITransactionType>>(`${url}`);
  }

  updateAccount(id: any, account: any): Observable<any> {
    console.log('updateAccount Values', account);
    //const url = this.urlService.buildUrl('account', 'update');
    // return this.http.post<any>(url, account)
    //   .pipe(
    //     catchError(this.errorMgmt)
    //   );

    const url = `${this.urlService.buildUrl('account', 'update')}/${id}`;
    return this.http
      .patch<any>(url, account, { headers: this.headers })
      .pipe(catchError(this.errorMgmt));
  }

  protected collectionname = 'organizations';
  protected _relativeUrl = 'organizations';

  ngOnInit(): void {
    this.collectionname = 'organizations';
  }
}
